// extracted by mini-css-extract-plugin
export default {"my-div":"register__my-div___xBouB","my-border":"register__my-border___qhcEP"};